module.exports = __webpack_public_path__ + "img/lock_timer_b.09074308.svg";